import React, { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './RouteTransition.module.css';

interface RouteTransitionProps {
  children: React.ReactNode;
}

const RouteTransition: React.FC<RouteTransitionProps> = ({ children }) => {
  const location = useLocation();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    el.classList.remove(styles.fadeIn);
    // Force reflow to re-trigger animation
    void el.offsetWidth;
    el.classList.add(styles.fadeIn);
    // Remove animation class after it completes to avoid creating a
    // persistent stacking context that traps position:fixed children
    // (e.g. modals) below the sticky header.
    const handleEnd = () => el.classList.remove(styles.fadeIn);
    el.addEventListener('animationend', handleEnd, { once: true });
    return () => el.removeEventListener('animationend', handleEnd);
  }, [location.pathname]);

  return (
    <div ref={containerRef} className={styles.routeTransition}>
      {children}
    </div>
  );
};

export default RouteTransition;
